/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  GetCampaignScheduleQueryResponse,
  GetCampaignSchedulePathParams,
  GetCampaignSchedule404,
} from '../../types/GetCampaignSchedule'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getCampaignSchedule } from '../../clients/getCampaignSchedule'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getCampaignScheduleQueryKey = ({
  campaign_id,
}: {
  campaign_id: GetCampaignSchedulePathParams['campaign_id']
}) =>
  [
    {
      url: '/api/v1/emailbison/campaigns/:campaign_id/schedule/',
      params: { campaign_id: campaign_id },
    },
  ] as const

export type GetCampaignScheduleQueryKey = ReturnType<
  typeof getCampaignScheduleQueryKey
>

export function getCampaignScheduleQueryOptions(
  {
    campaign_id,
  }: { campaign_id: GetCampaignSchedulePathParams['campaign_id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getCampaignScheduleQueryKey({ campaign_id })
  return queryOptions<
    GetCampaignScheduleQueryResponse,
    ResponseErrorConfig<GetCampaignSchedule404>,
    GetCampaignScheduleQueryResponse,
    typeof queryKey
  >({
    enabled: !!campaign_id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getCampaignSchedule(
        { campaign_id: campaign_id },
        { ...config, signal: config.signal ?? signal }
      )
    },
  })
}

/**
 * @description Get campaign schedule.
 * Returns:
 * Campaign schedule if exists, null otherwise
 * @summary Get campaign schedule
 * {@link /api/v1/emailbison/campaigns/:campaign_id/schedule/}
 */
export function useGetCampaignSchedule<
  TData = GetCampaignScheduleQueryResponse,
  TQueryData = GetCampaignScheduleQueryResponse,
  TQueryKey extends QueryKey = GetCampaignScheduleQueryKey,
>(
  {
    campaign_id,
  }: { campaign_id: GetCampaignSchedulePathParams['campaign_id'] },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetCampaignScheduleQueryResponse,
        ResponseErrorConfig<GetCampaignSchedule404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? getCampaignScheduleQueryKey({ campaign_id })

  const query = useQuery(
    {
      ...getCampaignScheduleQueryOptions({ campaign_id }, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<GetCampaignSchedule404>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
